<p-dialog [baseZIndex]="2000" [(visible)]="modal" [closable]="false" [closeOnEscape]="false" [dismissableMask]="false"
    [modal]="true" [position]="'center'" [draggable]="false">
    <div class="pr-3 pl-3">
        <h3 class="text-primary bold">Copy Paste Upload</h3>
        <div class="form-group mt-4">
            <span class="text-muted">Paste Text</span><b class="text-red ml-2">*</b>
            <textarea class="form-control" rows="10" [(ngModel)]="textInput"></textarea>
        </div>
        <!-- <div class="form-group" [formGroup]="form" *ngIf="form">
            <span class="text-muted">Assign Doctor to this LOA</span><b class="text-red ml-2"
                *ngIf="getControl('md_id')?.errors?.required">*</b>
            <app-doctor-autocomplete [doctorType]="'telemed7'" [(ngModel)]="form.controls['md_id'].value"
                (select)="getControl('md_id').setValue($event?.md_id)"
                (clear)="getControl('md_id').setValue(null)"></app-doctor-autocomplete>
        </div> -->
    </div>
    <p-footer>
        <div class="w-100 text-right pr-3 pl-3 pb-3">
            <button role="button" class="btn btn-primary btn-lg mr-2" (click)="extractDetails()" [disabled]="!textInput?.trim()">
                Extract Data
            </button>
            <button role="button" class="btn btn-outline-primary btn-lg" (click)="onClose()">
                Close
            </button>
        </div>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="showConfirmationModal" [modal]="true" [closable]="false" class="custom-modal">
    <div class="pr-3 pl-3">
        <h3 class="text-primary bold">Confirm Extracted Data</h3>
        <div class="mt-3">
            <table class="w-100">
                <tr>
                    <td><strong>Patient Timestamp <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.timestamp }}</td>
                </tr>
                <tr>
                    <td><strong>First Name <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.first_name }}</td>
                </tr>
                <tr>
                    <td><strong>Middle Name:</strong></td>
                    <td>{{ extractedData?.middle_name }}</td>
                </tr>
                <tr>
                    <td><strong>Last Name <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.last_name }}</td>
                </tr>
                <tr>
                    <td><strong>Gender <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.gender }}</td>
                </tr>
                <tr>
                    <td><strong>Member ID:</strong></td>
                    <td>{{ extractedData?.hmo_id }}</td>
                </tr>
                <tr>
                    <td><strong>Company:</strong></td>
                    <td>{{ extractedData?.company }}</td>
                </tr>
                <tr>
                    <td><strong>Date of Birth <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.dob }}</td>
                </tr>
                <tr>
                    <td><strong>Chief Complaint <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.chief_complaints }}</td>
                </tr>
                <tr>
                    <td><strong>Mobile #1 <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.mobile1 }}</td>
                </tr>
                <tr>
                    <td><strong>Mobile #2:</strong></td>
                    <td>{{ extractedData?.mobile2 }}</td>
                </tr>
                <tr>
                    <td><strong>Email <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.email }}</td>
                </tr>
                <tr>
                    <td><strong>Medical Certificate:</strong></td>
                    <td>{{ extractedData?.medical_certificate }}</td>
                </tr>
                <tr>
                    <td><strong>Approval Code <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.approval_code }}</td>
                </tr>
                <tr>
                    <td><strong>LOA Expiration Date <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.expiry_date }}</td>
                </tr>
                <tr>
                    <td><strong>Preferred Date/Time <b class="text-red">*</b>:</strong></td>
                    <td>{{ extractedData?.preferred_datetime }}</td>
                </tr>
            </table>
        </div>
    </div>
    <p-footer>
        <div class="w-100 text-right pr-3 pl-3 pb-3">
            <button class="btn btn-primary btn-lg mr-2" (click)="proceedWithData()" [disabled]="processing">Proceed</button>
            <button class="btn btn-outline-primary btn-lg" (click)="cancelConfirmation()" [disabled]="processing">Cancel</button>
        </div>
    </p-footer>
</p-dialog>


